goog.provide("shadow.js.shim.module$dayjs$locale$ar");
goog.provide("module$shadow_js_shim_module$dayjs$locale$ar");
shadow.js.shim.module$dayjs$locale$ar = shadow.js.nativeProvides["dayjs/locale/ar"] = require("dayjs/locale/ar");
module$shadow_js_shim_module$dayjs$locale$ar.default = shadow.js.shim.module$dayjs$locale$ar;
